import axios from 'axios';
import {Message} from 'element-ui';
// import { useI18n } from '../locales/useI18n';

// 设置基本URL
 const baseUrl =  'https://emc.b-tronsemi.com/emc-api/'; //根据需要修改base URL
// const baseUrl =  'http://127.0.0.1:8001/dev-emc-api/'; //根据需要修改base URL
// const baseUrl =  'http://test.emc-console.b-tronsemi.com/test-emc-api/';
// 创建 Axios 实例
const httpClient = axios.create({
    baseURL: baseUrl,
});

const uploadClient = axios.create({
    baseURL: baseUrl,
});

uploadClient.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'multipart/form-data;charset=UTF-8';
        config.headers['X-Access-Token'] = localStorage.token;  //localStorage.token 将token设置成请求头
        return config;
    },
);

// http request 拦截器
httpClient.interceptors.request.use(
    config => {
        if (localStorage.token) { //判断token是否存在
            config.headers['X-Access-Token'] = localStorage.token;  //localStorage.token 将token设置成请求头
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    },
);
// http response 拦截器
httpClient.interceptors.response.use(response => {
    const data = response.data;

    // 根据返回的code值来做不同的处理(和后端约定)
    switch (response.status) {
        case 401:
            // 未登录 清除已登录状态
            // Cookies.set('userInfo', '')
            // setStore('accessToken', '')
            // if (router.history.current.name !== 'login') {
            //     if (data.msg !== null) {
            //         Message.error(data.msg)
            //     } else {
            //         Message.error('未知错误，请重新登录')
            //     }
            //     router.push('/login')
            // }
            Message.error('未知错误，请重新登录');
            break;
        case 403:
            // 没有权限
            if (data.msg !== null) {
                Message.error(data.msg);
            } else {
                Message.error('未知错误');
            }
            break;
        case 500:
            // 错误
            if (data.msg !== null) {
                Message.error(data.msg);
            } else {
                Message.error('未知错误');
            }
            break;
        default:
        // return response
    }
    if (response.data && response.data.code && response.data.code != 0) {
        response.data.status = response.data.code;
        response.data.data = response.data.message;
    }
    return response;
}, (error) => {

    // const { t } = useI18n();
    const {response, code, message, config} = error || {};
    const msg = message;
    const err = error.toString();
    let errMessage = '';
    try {
        if (code === 'ECONNABORTED' && message.indexOf('timeout') !== -1) {
            errMessage = 'sys.api.apiTimeoutMessage';
        }
        if (err.includes('Network Error')) {
            errMessage = 'sys.api.networkExceptionMsg';
        }

        if (errMessage) {
            Message.error(errMessage);
            return Promise.reject(error);
        }
    } catch (error) {
        throw new Error(error);
    }

    switch (error.response.status) {
        case 400:
            errMessage = response.data.message || message;
            break;
        // 401: Not logged in
        // Jump to the login page if not logged in, and carry the path of the current page
        // Return to the current page after successful login. This step needs to be operated on the login page.
        case 401:
            // userStore.setToken(undefined);
            errMessage = response.data.message || msg || 'sys.api.errMsg401';
            // if (stp === SessionTimeoutProcessingEnum.PAGE_COVERAGE) {
            //     userStore.setSessionTimeout(true);
            // } else {
            //     userStore.logout(true);
            // }
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.open('/login', '_self');
            // windows.location.href = '/login';
            break;
        case 403:
            errMessage = 'sys.api.errMsg403';
            break;
        // 404请求不存在
        case 404:
            errMessage = ('sys.api.errMsg404');
            break;
        case 405:
            errMessage = ('sys.api.errMsg405');
            break;
        case 408:
            errMessage = ('sys.api.errMsg408');
            break;
        case 500:
            errMessage = response.data.message || ('sys.api.errMsg500');
            break;
        case 501:
            errMessage = ('sys.api.errMsg501');
            break;
        case 502:
            errMessage = ('sys.api.errMsg502');
            break;
        case 503:
            errMessage = ('sys.api.errMsg503');
            break;
        case 504:
            errMessage = ('sys.api.errMsg504');
            break;
        case 505:
            errMessage = ('sys.api.errMsg505');
            break;
        default:
    }
    // 返回状态码不为200时候的错误处理
    Message.error(errMessage);

    return Promise.resolve(err);
});

export default {
    get(url, params = {}) {
        return httpClient.get(`${url}${Object.keys(params).length ? '?' : ''}${objectToQueryString(params)}`);
    },

    post(url, data) {
        return httpClient.post(url, data);
    },

    put(url, data) {
        return httpClient.put(url, data);
    },

    patch(url, data) {
        return httpClient.patch(url, data);
    },

    delete(url, data) {
        return httpClient.delete(url, data);
    },

    download(url, params = {}) {
        this.downloadFile(`${url}${Object.keys(params).length ? '?' : ''}${objectToQueryString(params)}`,params);
    },
    downloadFile(url, params = {}) {
        httpClient.get(url, {responseType: 'blob'}).then(response => {
            console.info('downloadFile:', response);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            let fileName = '下载.xlsx';
            let temp = response.headers['filename'];
            fileName = decodeURIComponent(temp);
            link.setAttribute('download', params.fileName || fileName);
            document.body.appendChild(link);
            link.click();
        }).catch(error => {
            console.error(error);
        });
    },
    upload(url, data = {}) {
        return uploadClient.post(url, data);
    },
};

function objectToQueryString(obj, parentKey = '') {
    let queryString = [];
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            let fullKey = parentKey ? `${parentKey}[${key}]` : key;
            let fullKey2 = parentKey ? `${parentKey}.${key}` : key;
            let value = obj[key];
            if (value instanceof Array) {
                queryString.push(
                    value.map(id => `${fullKey}=${encodeURIComponent(id)}`).
                        join('&'));
            } else if (value instanceof Object) {
                // 如果值是对象，递归调用
                queryString.push(objectToQueryString(value, fullKey));
            } else {
                queryString.push(encodeURIComponent(fullKey2) + '=' +
                    encodeURIComponent(value));
            }
        }
    }
    return queryString.join('&');
}


// WEBPACK FOOTER //
// ./src/api/http.js